Vue.config.devtools = true;
import Vue from 'vue';
import App from '@/App.vue';
import {
  AlertPlugin,
  ButtonGroupPlugin,
  ButtonPlugin,
  FormFilePlugin,
  FormInputPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  InputGroupPlugin,
  LayoutPlugin,
  ListGroupPlugin,
  ModalPlugin,
  NavbarPlugin,
  SidebarPlugin,
  TablePlugin
} from 'bootstrap-vue';
import '@/app.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import router from '@/router';
import store from '@/store';

Vue.use(AlertPlugin);
Vue.use(ButtonGroupPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormFilePlugin);
Vue.use(FormInputPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormSelectPlugin);
Vue.use(InputGroupPlugin);
Vue.use(LayoutPlugin);
Vue.use(ListGroupPlugin);
Vue.use(ModalPlugin);
Vue.use(NavbarPlugin);
Vue.use(SidebarPlugin);
Vue.use(TablePlugin);

Vue.config.devtools = true;
Vue.config.productionTip = false;

new Vue({
  router: router,
  store: store,
  render: function (h) {
    return h(App);
  }
}).$mount('#app');
